import React from 'react'
import { useIntl } from "react-intl";
import './magazine.scss'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ChevronIcon from "../../../svg-icons/chevron-icon";
import { END_POINTS } from 'constants/APIConstant';
import useSWR from "swr";
import ContentLoading from 'component/LoadingComponent/ContentLoading';
import HtmlView from 'component/htmlView/html-view';
import DataNotFound from 'component/shared/DataNotFound/DataNotFound';
import AOS from 'aos';
import 'aos/dist/aos.css'
import LabelLang, { LabelLangString } from 'component/LabelLang/label-lang';
import { useSelector } from 'react-redux';
import { API_BASE_URL } from 'configs/AppConfig';
import ReactGA from "react-ga4";

export default function Magazine() {

    const intl = useIntl();

    React.useEffect(() => {   
        AOS.init();
        AOS.refresh();
    }, [])


    ReactGA.initialize(END_POINTS.TRACKING_ID);

    React.useEffect(() => {
        // Send pageview with a custom path
        ReactGA.send({ hitType: "pageview", page: "/mediaLanding/magazine", title: "Magazine Page" });
    }, []);


    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const journalData = useSWR({
        url: END_POINTS.EGYPT_STATISTICS_JOURNAL,
    });

    React.useEffect(() => {
            setExpanded(`panel${0}`);
    }, []);

    const currentLocale = useSelector(({ theme }) => theme.locale);

    const renderJournalData = () => {
        const statisticsData =
            journalData.error ||
            journalData.isLoading ||
            journalData.data === undefined
            ? []
            : journalData.data.data.egyptStatisticsJournalList;
        const rendering = statisticsData.map(({ year , egyptStatisticsJournal } , i) => {
                return (
                    <Accordion
                        className="mb-2"
                        expanded={expanded === `panel${i}`}
                        onChange={handleChange(`panel${i}`)}
                        key={i}
                    >
                        <AccordionSummary
                            aria-controls={`panel${i}bh-content`}
                            id={`panel${i}bh-header`}
                            className={"coll-item-headr"}
                        >
                            <div
                                className={`icon ${
                                    expanded === `panel${i}` ? "open" : "close"
                                }`}
                            >
                                <i className="fas fa-minus"></i>
                                <i className="fas fa-plus"></i>
                            </div>
                            <h5>{`${intl.formatMessage({ id: "magazine-issues" })} ${year}`}</h5>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{ textAlign: "start", paddingInlineStart: "2rem" }}
                            className="coll-dateils"
                        >
                            <div className="row gy-3 mt-2 justify-content-center align-items-center">
                                <div className="col-12 col-lg-8">
                                    {egyptStatisticsJournal.map(({ title, content, url, egyptStatisticsJournalTranslations } , i) => (
                                        <div key={i} className="calnd-info">
                                            <h5>
                                                <a href={`${API_BASE_URL}${url}`} target="_blank" rel="noopener noreferrer">
                                                    <ChevronIcon width={20} height={10} />
                                                    <LabelLang
                                                        id="title"
                                                        defaultValue={title}
                                                        translations={egyptStatisticsJournalTranslations}
                                                    />
                                                </a>
                                            </h5>
                                            <h6>{intl.formatMessage({ id: "read-in-this-issue" })}:</h6>
                                            {content !== null ? (
                                                <ul className="listt">
                                                    <HtmlView html={
                                                            LabelLangString({
                                                                id: "content",
                                                                currentLocale: currentLocale,
                                                                defaultValue: content,
                                                                translations: egyptStatisticsJournalTranslations,
                                                            })
                                                        }
                                                    />
                                                </ul>
                                            ) : (
                                                <DataNotFound />
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="col-12 col-lg-4">
                                    <div>
                                        <img 
                                            className="img-fluid"
                                            src={process.env.PUBLIC_URL + "/image/pr.svg"}
                                            alt="back-ground"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                );
            }
        );
        return rendering;
    };

  return (
    <ContentLoading isLoading={journalData.isLoading} >
        <div className='magazine'>
            <div className='m__title__magazine' data-aos='fade-down' data-aos-duration="1000" data-aos-easing="ease-in-sine">
                <h3>{intl.formatMessage({ id: "egyptian-statistical-review" })}</h3>
                <p>
                    <LabelLang 
                        id={'value'}
                        defaultValue={journalData?.data?.data?.egyptStatisticsJournalDescription?.value}
                        translations={journalData?.data?.data?.egyptStatisticsJournalDescription?.elementTranslations}
                        />
                </p>
            </div>
            <div className="OrganizationalChart-coll" data-aos='fade-up' data-aos-duration="1000" data-aos-easing="ease-out-sine">
                {Object.keys(renderJournalData()).length > 0 ?
                    renderJournalData()
                    :
                    <DataNotFound />
                }
            </div>
        </div>
    </ContentLoading>
  )
}